import React from 'react';
import ReactMarkdown, { ReactMarkdownProps } from 'react-markdown';
import { styled, css } from '@goodrx/matisse';
import { useAppContext } from 'app/config/AppContext';

const MarkdownContainer = styled.div<{ headerFontFamily: string; baseFontFamily: string }>`
  ${(p) =>
    css`
      h1 {
        font-family: ${p.headerFontFamily} !important;
        font-size: 22px;

        &:first-child {
          margin-top: 0px;
        }
      }
      h2 {
        font-family: ${p.baseFontFamily} !mportant;
        font-size: 20px;
        margin: 24px 0 12px;
      }

      h3 {
        font-size: 18px;
        margin: 16px 0 8px;
        font-weight: 500;
      }

      ul {
        list-style: initial;
        margin-left: 0px;

        li + li {
          margin-top: 8px;
        }
      }

      h2 + p,
      h3 + p {
        margin-top: 0;
      }
    `}
`;

export default function Markdown(props: ReactMarkdownProps) {
  const {
    config: {
      Theme: {
        typography: { baseFontFamily, headerFontFamily },
      },
    },
  } = useAppContext();

  return (
    <MarkdownContainer baseFontFamily={baseFontFamily} headerFontFamily={headerFontFamily}>
      <ReactMarkdown {...props} />
    </MarkdownContainer>
  );
}
